module.exports = __webpack_public_path__ + "img/MORDOV.c23ab76b.png";